<template>
  <q-list bordered separator>
    <q-item to="/statement" clickable v-ripple>
      <q-item-section>Statement Enquiry</q-item-section>
      <q-item-section side>
        <q-icon name="keyboard_arrow_right" />
      </q-item-section>
    </q-item>

    <q-item to="/report" clickable v-ripple>
      <q-item-section>DA Report Status Check</q-item-section>
      <q-item-section side>
        <q-icon name="keyboard_arrow_right" />
      </q-item-section>
    </q-item>
  </q-list>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('auth', ['handleLogin', 'setActiveRoute'])
  },
  mounted () {
    this.setActiveRoute('dashboard')
    this.handleLogin()
  }
}
</script>

<style lang="scss" scoped>
</style>
